import $ from 'jquery';

$(document).ready(function() {
    $(document).on('click', '.js-universal-accordion-arrow', function() {
    	$(this).parents('.js-universal-accordion').toggleClass('active');
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/universal/universal-accordion.js